import React, { useState } from "react";
import { useAsync } from "react-async-hook";
import { adminCreateAccessGroup, adminDeleteAccessGroup, adminGetAccessGroups, adminGetServices, adminSetAccessGroup } from "src/app/api/AdminApi";
import AppSpinner from "src/commun/composants/AppSpinner/AppSpinner";
import styles from "src/pages/admin/adminAccessGroup/AdminAcessGroupeForm.scss";
import AppRow from "src/commun/composants/grille/AppRow";
import AppCol from "src/commun/composants/grille/AppCol";
import useValidationAdminAccessGroupSchemaService from "src/pages/admin/adminAccessGroup/useValidationAccessGroupSchemaService";
import { AdminAccessGroup } from "src/domain/AdminAccessGroup";
import { useAppText } from "src/commun/composants/AppText";
import AppMessage from "src/commun/composants/AppMessage/AppMessage";
import AdminAccessGroupRow from "src/pages/admin/adminAccessGroup/AdminAccessGroupLigne";
import AppFormik from "src/commun/composants/formulaire/formik/AppFormik";
import AdminAccessGroupAddLigne from "src/pages/admin/adminAccessGroup/AdminAccessGroupAddLigne";


const AdminAccessGroupForm = () => {


  const emptyAdminAcessFroup: AdminAccessGroup = {
    id: 0,
    accessGroup: "",
    typeAcces: "",
  };

  const validationSchema = useValidationAdminAccessGroupSchemaService();

  const [add, setAdd] = useState(false);
  const accessGroups = useAsync(adminGetAccessGroups, []);
  const services = useAsync(adminGetServices, []);
  const { tString } = useAppText();
  const submitSuccessHandler = () => {

    accessGroups.execute();
  };

  if (accessGroups.status === "loading" ||services.status === "loading") {
    return <AppSpinner animation="grow"/>;
  }

  const handleSubmitForm = (accessGroup: AdminAccessGroup) => {
    return adminSetAccessGroup({
      ...accessGroup,
    } as AdminAccessGroup);
  };

  const handleCreateForm = (accessGroup: AdminAccessGroup) => {
    return adminCreateAccessGroup({
      ...accessGroup,
    } as AdminAccessGroup);
  };



  const renderHead = () => {

    return (
      <tr>
        <th>{tString("admin.accessgroup.titre.nom.groupe")}</th>
        <th>{tString("admin.accessgroup.titre.type.acces")}</th>
        <th>{tString("admin.accessgroup.titre.actions")}</th>
        <th></th>
      </tr>
    );
  };

  const renderLine = (accessGroup: AdminAccessGroup,index:number) => {
    const isUse = services.result?.some(service =>
      service.accessGroups.some(group => group.id === accessGroup.id)
    );

    return (
      <AppFormik
        key={index}
        enableReinitialize
        initialValues={accessGroup}
        submitFormAPI={(publicite: AdminAccessGroup) => handleSubmitForm(publicite)}
        submitSuccessHandler={submitSuccessHandler}
        validationSchema={validationSchema}
      >
        <AdminAccessGroupRow accessGroup={accessGroup} onDelete={onDeleteCallBack(accessGroup)}
       onEdit={() => {
       }}
       isDelete={!isUse}
        ></AdminAccessGroupRow>
      </AppFormik>
    );
  };


  const onDeleteCallBack = (accessGroup: AdminAccessGroup) =>{
    return (): void => {
      adminDeleteAccessGroup(accessGroup).then(()=>{
        submitSuccessHandler();
        setAdd(false)
      }).then(()=>{setAdd(false)})

    };
  }


  const renderLineAdd = (accessGroup: AdminAccessGroup) => {



    return (
      <AppFormik
        key={"add"}
        enableReinitialize
        initialValues={accessGroup}
        submitFormAPI={(publicite: AdminAccessGroup) => handleCreateForm(publicite)}
        submitSuccessHandler={submitSuccessHandler}
        validationSchema={validationSchema}
      >
        <AdminAccessGroupAddLigne accessGroup={accessGroup} onDelete={onDeleteCallBack(accessGroup)} onEdit={() => {
        }}></AdminAccessGroupAddLigne>
      </AppFormik>
    );
  };


  return (
    <span className={`ferge-class`}>
      <AppRow>
        <AppCol md={{ span: 12 }}>
            <div className={`${styles.container}`}>
              <h2 className="appTitle">Administrer les groupes</h2>
              {(!accessGroups.result || accessGroups.result.length === 0) ?
                <AppMessage messageType="INFO" children={<>{tString("documents.info.pasDeDocuments")}</>}/>
                :
                (
                  <table className={styles.tableDocuments}>
                    <thead>
                    {renderHead()}
                    </thead>
                    <tbody>
                    {accessGroups.result?.map((ag,index) => renderLine(ag,index))}
                    {renderLineAdd({id:0,accessGroup:"",typeAcces:"Entreprise"})}
                    </tbody>
                  </table>
                )
              }
            </div>
        </AppCol>
      </AppRow>
    </span>
  );
};


export default AdminAccessGroupForm;